import 'arrive';
import $ from 'jquery';

document.arrive('.block-publication-list', { existing: true }, function () {

    var $target = $('#products-grid');
    var $fixedShuffle = $('.block-publication-list__fixed-shuffle');
    var $footer = $('footer'); // o il selettore del tuo footer
    var $section = $('.block-publication-list');

    var currentPage = parseInt($section.data('page'));
    var totalProducts = parseInt($section.data('total'));
    var perPage = parseInt($section.data('per-page'));
    var ajaxUrl = $section.data('ajax-url');
    var nonce = $section.data('nonce');
    var loading = false;

    // Contatore reale dei prodotti già presenti
    var loadedProducts = $target.find('.product-item').length;

    function checkVisibilityShuffle() {
        if (!$target.length || !$fixedShuffle.length) return;

        var windowTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var footerTop = $footer.length ? $footer.offset().top : $(document).height();

        // Mostra solo se abbiamo almeno 9 prodotti
        if (loadedProducts >= 9) {
            if (windowTop + windowHeight >= footerTop) {
                $fixedShuffle.removeClass('show');
            } else {
                $fixedShuffle.addClass('show');
            }
        } else {
            $fixedShuffle.removeClass('show');
        }
    }

    // Controlla visibilità all'avvio
    checkVisibilityShuffle();

    // Scroll handler unico per shuffle e load more
    $(window).on('scroll', function() {
        checkVisibilityShuffle();

        if (loading || loadedProducts >= totalProducts) return;

        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var footerTop = $footer.length ? $footer.offset().top : $(document).height();

        if (scrollTop + windowHeight >= footerTop - 200) {
            loadMoreProducts();
        }
    });

    function loadMoreProducts() {
        if (loading) return;

        loading = true;
        currentPage++;

        $('.loading-more').show();

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'load_more_products',
                page: currentPage,
                per_page: perPage,
                nonce: nonce
            },
            success: function(response) {
                if (response.success) {
                    var $grid = $('#products-grid');
                    var $html = $(response.data.html);
                    // Seleziona i nuovi elementi product-item
                    var $newItems = $html.find('.product-item');
                    if ($newItems.length === 0) {
                        // fallback: se il server ritorna direttamente item di primo livello
                        $newItems = $html.filter('.product-item');
                    }
                    // Stato iniziale invisibile + leggero shift
                    $newItems.css({ opacity: 0, transform: 'translateY(8px)' });

                    // Append al grid
                    $grid.append($html);

                    // Forza reflow per attivare la transition
                    if ($newItems.length) { $newItems[0].offsetHeight; }

                    // Attiva fade-in
                    $newItems.css({ opacity: 1, transform: 'translateY(0)' });

                    // Aggiorna il contatore reale
                    loadedProducts = $target.find('.product-item').length;

                    checkVisibilityShuffle(); // aggiorna subito la fixed bar

                    if (!response.data.has_more) {
                        loadedProducts = totalProducts;
                    }
                }
                $('.loading-more').hide();
                loading = false;
            },
            error: function() {
                $('.loading-more').hide();
                loading = false;
            }
        });
    }

    // Shuffle Products
    $('#shuffle-products').on('click', function() {
        var $grid = $('#products-grid');
        var $items = $grid.children('.product-item');

        // Fade-out rapido prima dello shuffle
        $items.css({ opacity: 0, transform: 'translateY(8px)', transition: 'opacity 200ms ease, transform 200ms ease' });

        setTimeout(function() {
            // Shuffle
            var shuffled = $items.sort(function() {
                return Math.random() - 0.5;
            });
            $grid.append(shuffled);

            // Forza reflow
            if (shuffled.length) { shuffled[0].offsetHeight; }

            // Fade-in degli elementi nella nuova posizione
            $grid.children('.product-item').css({ opacity: 1, transform: 'translateY(0)', transition: 'opacity 250ms ease, transform 250ms ease' });

            $grid.addClass('shuffling');
            setTimeout(function() {
                $grid.removeClass('shuffling');
            }, 300);
        }, 200);
    });
});
